$(document).ready(function(){

    var id = $('input[name="location"]').attr('value');
    var buttons = $('.s-contact__location button');
    if (id == undefined){ id = buttons.first().attr('value'); }

    $('.s-contact__location button[value="' + id + '"]').attr('class', 'c-btn c-btn--filled c-btn--inv-filled-2 c-btn--md-width-full');
    $('.s-contact__id--'+id).addClass('s-contact__id--show');


    $('.s-contact__location button').click(function(){
        $('.s-contact__location button').attr('class', 'c-btn c-btn--filled c-btn--inv-border-2 c-btn--md-width-full');
        $(this).attr('class', 'c-btn c-btn--filled c-btn--inv-filled-2 c-btn--md-width-full');
        var id = $(this).attr('value');
        $('.s-contact__id').removeClass('s-contact__id--show');
        $('.s-contact__id--'+id).addClass('s-contact__id--show');
        $('input[name="location"]').attr('value', id);
    });

});
